import type { FlagRecord } from "../../../lib/types/schema/moderation/flagRecordSchema";
import type { UseRequestMutationProps } from "../../../request/hooks/useRequestMutation";
import { useRequestMutation } from "../../../request/hooks/useRequestMutation";

export type UseRequestFlagRecordProps = UseRequestMutationProps<
  any,
  FlagRecord
>;

export const useRequestFlagRecord = ({
  ...props
}: UseRequestFlagRecordProps = {}) => ({
  mutationPost: useRequestMutation({
    ...props,
    mutationFnRequestProps: (data: FlagRecord) => ({
      body: JSON.stringify(data),
      urlBackendPath: "/moderation/flag-record",
    }),
  }),
});
